import { FC } from 'react'
import { SquareButton } from '../atoms';
import AddPropertyIcon from '@/assets/addButtonsIcons/house-icon.svg';
import AddOwnerIcon from '@/assets/addButtonsIcons/user-add-0.svg';
import AddUserIcon from '@/assets/addButtonsIcons/user-add-1.svg';
import AddContractIcon from '@/assets/addButtonsIcons/note-icon.svg';
import AddExpenseIcon from '@/assets/addButtonsIcons/money-icon.svg';
import AddSupplierIcon from '@/assets/addButtonsIcons/user-add-2.svg';
import AddIncidentIcon from '@/assets/addButtonsIcons/receipt-edit-icon.svg';
import ContactUsIcon from '@/assets/addButtonsIcons/comunication-icon.svg';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { pathURL } from '@/components/constants/urls';
import { useOpeningElementsControllerContext } from '@/customHooks';


const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto repeat(3, 1fr);
  gap: 10px;
  width: 500px;
  grid-template-areas:
  "header header header"
  "button1 button2 button3"
  "button4 button5 button6"
  "button7 button8 button9";
  `;

export const AddNewMenuCard: FC = () => {
  const navigate = useNavigate()
  const { addMenuModalClose } = useOpeningElementsControllerContext()

  const buttons = [
    { text: 'Property', action: () => navigate(`/${pathURL.USER}/${pathURL.PROPERTY}/${pathURL.CREATE}`), selected: true, icon: AddPropertyIcon },
    { text: 'Owner', action: () => navigate(`/${pathURL.USER}/${pathURL.OWNER}/${pathURL.CREATE}`), selected: false, icon: AddOwnerIcon },
    { text: 'User', action: () => console.log('Add User'), selected: false, icon: AddUserIcon },
    { text: 'Contract', action: () => navigate(`/${pathURL.USER}/${pathURL.CONTRACT}/${pathURL.CREATE}`), selected: false, icon: AddContractIcon },
    { text: 'Expense', action: () => console.log('Add Expense'), selected: false, icon: AddExpenseIcon },
    { text: 'Supplier', action: () => navigate(`/${pathURL.USER}/${pathURL.SUPPLIER}/${pathURL.CREATE}`), selected: false, icon: AddSupplierIcon },
    { text: 'Incident', action: () => navigate(`/${pathURL.USER}/${pathURL.INCIDENTS}/${pathURL.CREATE}`), selected: false, icon: AddIncidentIcon },
    { text: 'Tenant', action: () => navigate(`/${pathURL.USER}/${pathURL.TENANT}/${pathURL.CREATE}`), selected: false, icon: AddUserIcon },
    { text: 'Contact Us', action: () => console.log('Contact Us'), selected: false, icon: ContactUsIcon }
  ];

  return (
    <GridWrapper>
      <div style={{ gridArea: 'header' }}>
        <h1>Add New</h1>
      </div>
      {buttons.map((btn, index) => (
        <SquareButton
          key={index}
          action={() => {
            btn.action()
            addMenuModalClose()
          }}
          selected={btn.selected}
        >
          <>
            <img src={btn.icon} alt={btn.text} />
            <span>{btn.text}</span>
          </>
        </SquareButton>
      ))}
    </GridWrapper>
  );
};
